package com.eladfinish.bible.contest.screens.main

import com.eladfinish.bible.contest.analytics.AnalyticsConstants
import com.eladfinish.bible.contest.screens.main.data.ButtonType

/** The button by the name the saved button order uses (see ButtonTypeSerializer). */
internal fun mainButtonClickedParams(buttonType: ButtonType, position: Int): Map<String, Any> = mapOf(
    AnalyticsConstants.MainButton.PARAM_BUTTON to buttonType.name.lowercase(),
    AnalyticsConstants.MainButton.PARAM_POSITION to position,
)
